<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-12 mb-lg-0">
          <router-link class="" to="/">

          <img
            :src="
              this.$store.state.darkMode
                ? logoWhiteFooter
                : logoDarkFooter
            "
            class="navbar-brand-img h-100"
            alt="main_logo_footer"
            style="max-height: 4rem;"
          /> 
          </router-link>
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, Desarrollado por
            <a href="https://mistock.co/" class="text-bold ">MISTOCK.CO</a>
            
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

import logoWhiteFooter from "@/assets/img/mistockwhite.png";
import logoDarkFooter from "@/assets/img/mistockdark.png";
export default {
  name: "app-footer",
  data() {
    return {
      logoWhiteFooter,
      logoDarkFooter
    };
  },
};
</script>
